import { Box, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import BottomButtons from "./bottomButtons";
import ScoreButtonGroup from "./scoreButtonGroup";
import { DART_NUMBER } from "../types/dart";
import { PLAYER } from "../types/players";
import { X01VerticalOrder, X01Order, X01_ORDER } from "../types/x01";
import {
  getGestureHelpLocalStorage,
  getGestureLocalStorage,
  getX01OrderLocalStorage,
} from "../util/localStorage";
import GestureHelp from "../views/gestureHelp";

interface AllButtonsProps {
  onClickHandler: Function;
  undoHandler: Function;
  inUndoState: boolean;
  currentPlayer?: PLAYER;
  botTurn?: boolean;
  trueColor?: boolean;
}

export default function AllButtons({
  onClickHandler,
  currentPlayer = PLAYER.FIRST,
  botTurn = false,
  undoHandler,
  inUndoState,
  trueColor = false
}: AllButtonsProps) {
  const show = getGestureLocalStorage() && getGestureHelpLocalStorage();
  const storageNumberOrder = getX01OrderLocalStorage();
  const [showGestureHelp, setShowGestureHelp] = useState(show);
  const [numberOrder, setNumberOrder] = useState<X01_ORDER>(storageNumberOrder);
  const desktopArray =
    numberOrder === X01_ORDER.HORIZONTAL ? X01Order : X01VerticalOrder;

  useEffect(() => {
    setShowGestureHelp(show);
  }, [show]);

  useEffect(() => {
    setNumberOrder(getX01OrderLocalStorage());
  }, [storageNumberOrder]);

  const hideGestureHandler = () => {
    setShowGestureHelp(false);
  };

  return (
    <Wrapper>
      <DesktopButtons>
        <DesktopNumberButtons>
          {desktopArray.map((number) => {
            return (
              <ScoreButtonGroup
                key={number}
                number={number}
                player={currentPlayer}
                disabled={botTurn}
                multiples={number === DART_NUMBER.BULL ? 2 : 3}
                onClickHandler={onClickHandler}
              />
            );
          })}
        </DesktopNumberButtons>
        <Box marginTop={1}>
          <BottomButtons
            undoHandler={undoHandler}
            onClickHandler={onClickHandler}
            botTurn={botTurn}
            inUndoState={inUndoState}
          />
        </Box>
      </DesktopButtons>
      <MobileButtons>
        {showGestureHelp ? (
          <GestureHelp hideGestureHandler={hideGestureHandler} />
        ) : (
          <React.Fragment>
            <MobileNumberButtons>
              {X01Order.map((number) => {
                return (
                  <ScoreButtonGroup
                    key={number}
                    number={number}
                    player={currentPlayer}
                    disabled={botTurn}
                    multiples={1}
                    onClickHandler={onClickHandler}
                    mobileButtons={true}
                  />
                );
              })}
            </MobileNumberButtons>
            <Box>
              <BottomButtons
                undoHandler={undoHandler}
                onClickHandler={onClickHandler}
                botTurn={botTurn}
                inUndoState={inUndoState}
              />
            </Box>
          </React.Fragment>
        )}
      </MobileButtons>
    </Wrapper>
  );
}

const Wrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
});

const DesktopButtons = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  borderLeft: "4px double black",
  borderRight: "4px double black",
  padding: "0 4px",
  "@media(max-width: 960px)": {
    alignSelf: "center",
    width: "95%",
  },
  "@media(max-width: 650px)": {
    display: "none",
  },
});

const MobileButtons = styled(Box)({
  paddingTop: "10px",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  gap: "10px",
  "@media(min-width: 651px)": {
    display: "none",
  },
});

const MobileNumberButtons = styled(Box)({
  // flex: 2,
  display: "grid",
  height: "90%",
  gridTemplateColumns: "1fr 1fr 1fr",
  gap: "4px",
});

const DesktopNumberButtons = styled(Box)({
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  gap: "4px",
  flex: 2,
});
